import { VoiceCallBridgeToAgent, VoiceCallDial, VoiceCallGenerateAppToken, VoiceCallListenIn, VoiceCallStartedBody } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/messaging/src/API/Voice/VoiceCall.Controller.ts

export class VoiceAPI {
  static async callStarted(options: VoiceCallStartedBody): Promise<string> {
    return APIService.Messaging.post<string>(`/voice/`, options);
  }

  static async createOutboundCall(options: VoiceCallDial): Promise<string> {
    return APIService.Channels.post<string>("/channels/voice/call/dial", options);
  }
  static async generateMemberTwilioToken(options: VoiceCallGenerateAppToken): Promise<{ token: string }> {
    return APIService.Channels.put<{ token: string }>("/channels/voice/app/token", options);
  }
  static async bridgeToAgent(options: VoiceCallBridgeToAgent): Promise<void> {
    return APIService.Channels.post<void>("/channels/voice/app/bridge", options);
  }
  static async listenIn(options: VoiceCallListenIn): Promise<{ roomName: string }> {
    return APIService.Channels.post<{ roomName: string }>("/channels/voice/app/listen-in", options);
  }
}
